module.exports = __webpack_public_path__ + "media/images/flt-icon-98073d1b7214f9febb87ad86ce52a150.png";